module.exports = __webpack_public_path__ + "static/media/download_icon.be7cdac2.svg";